import React, { useEffect } from 'react';

export interface DrawerProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onClose?: () => void;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose, children }) => {
  useEffect(() => {
    const page = document.getElementsByClassName('product-category-single') as HTMLCollectionOf<HTMLElement>;
    if (isOpen && page.length > 0) {
      page[0].style.zIndex = '10';
    } else {
      page[0].style.zIndex = '0';
    }
  }, [isOpen]);

  return (
    <div>
      <div className={`drawer ${isOpen ? 'open' : ''}`}>
        <div className="drawer__content">{children}</div>
      </div>

      {isOpen && <div className="backdrop"></div>}
    </div>
  );
};

export default Drawer;
